// HoloCard.jsx
import React, { forwardRef } from "react";
import "./HoloCard.css";

const HoloCard = forwardRef(
  (
    {
      image,
      topLayer,
      foil,
      mask,
      width,        
      height,   
      heightTop = 210,
      onClick,
      glow = false,
      borderRadius,
      rarity,
    },
    ref
  ) => {
    const fixedSize = width !== undefined && height !== undefined;

    return (
      <div
        ref={ref}
        className={`card-holo rarity-${rarity} ${fixedSize ? "is-fixed" : "is-fluid"}`}
        onClick={onClick}
        style={{
          ...(fixedSize && { width, height }), // only lock when provided

          "--foil": `url(${foil})`,
          "--mask": `url(${mask})`,
          boxShadow: glow
            ? "0 15px 35px rgba(0,0,0,0.5), 0 0 50px rgba(255,255,255,0.2), 0 0 80px rgba(255,255,255,0.3)"
            : undefined,
          borderRadius,
        }}
      >
        <img className="card-holo__image" src={image} alt="" />

        {rarity === "event" && <div className="card-holo__event-foil" />}

        <div className={`card-holo__shine rarity-${rarity}`} />

        {topLayer && rarity === "special" && (
          <img
            className="card-holo__top__image"
            src={topLayer}
            alt=""
            draggable={false}
            style={{ height: fixedSize ? heightTop : "70%" }}
          />
        )}

        <div className="card-holo__mask" />
      </div>
    );
  }
);

export default HoloCard;
